import { createAction, props } from '@ngrx/store';
import { TaxApiResponse } from 'src/app/shared/types/tax';

const taxIsCreated = 'TAX_IS_CREATED';
const removeRecentTax = 'REMOVE_RECENT_TAX';
const restrictCreateTaxToOutputTax = 'RESTRICT_CREATE_TAX_TO_OUTPUT_TAX';
export const taxIsCreatedAction = createAction(
  taxIsCreated,
  props<{ newTax: TaxApiResponse['data'] }>()
);

export const removeRecentTaxAction = createAction(removeRecentTax);
export const restrictCreateTaxToOutputTaxAction = createAction(
  restrictCreateTaxToOutputTax,
  props<{ restrict: boolean }>()
);
